export default "__VITE_ASSET__Co094w2H__"